import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'

import { ShortcutIconName } from '@flowx/designer/modules/ai/types/ai.types'
import { KeyboardKeyCode } from '@flowx/designer/modules/bpmn-editor/fabric.util'

import { AiIconsModule } from '../../../../common/icons/ai-icons.module'

export enum IconType {
  ICON = 'icon',
  KEY = 'key',
}

export enum AiKeyboardKeyCode {
  CONFIRM = KeyboardKeyCode.CONFIRM,
  GENERATE = KeyboardKeyCode.GENERATE,
  CANCEL = 'esc',
  NEW = 'n',
}

export type ShortcutConfig = {
  label?: string
  icons: { type: IconType; name: ShortcutIconName | string }[]
}

@Component({
  selector: 'flx-ai-shortcut',
  imports: [CommonModule, AiIconsModule],
  templateUrl: './shortcut.component.html',
  styleUrls: ['./shortcut.component.scss'],
})
export class AiShortcutComponent {
  @Input() label?: ShortcutConfig['label']
  @Input() icons: ShortcutConfig['icons']
  @Input() bgClass?: string

  IconType = IconType
}
